<template>
  <div>

    <z-centralized-toolbar>

      <v-toolbar-items>
        <v-btn id="btn-adicionar" text small color="primary" @click="adicionar">
          <v-icon left>mdi-calendar-clock</v-icon>Adicionar
        </v-btn>

        <v-btn text id="btn-atualizar" @click="refresh" :loading="$store.state.loading">
          <v-icon>mdi-refresh</v-icon>
          <v-tooltip bottom activator="#btn-atualizar">
            Atualizar
          </v-tooltip>
        </v-btn>
      </v-toolbar-items>

      <!-- <v-spacer></v-spacer> -->

      <z-text-field-search
        v-model="busca"
        select
        class="ml-5"
        @keydown.enter="buscar"
        @click:clear="limparBusca"
      ></z-text-field-search>
    </z-centralized-toolbar>

    <v-divider></v-divider>

    <z-scroll-layout :top-position="$v.TOP_POSITION">
      <z-container>
            
        <z-cabecalho>{{$store.state.titulo_tela}}</z-cabecalho>
        
        <v-card>
          <v-data-table
          mobile-breakpoint="0"
            :options.sync="paginacao" 
            :server-items-length="total_itens" 
            :footer-props="$v.FOOTER_PROPS" 
            :headers="headers"
            :items="prazos"
            item-key="id"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.id }}</td>
                <td>{{ item.descricao }}</td>
                <td class="text-right">{{ item.parcelas }}</td>
                <td class="text-right">{{ item.juros }} %</td>
                <td class="text-center">
                  <v-btn icon @click="editar(item)" class="ma-0">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon @click="perguntarExcluir(item)" class="ma-0">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
        
      </z-container>
    </z-scroll-layout>

    <z-dialogo-sim-nao ref="dialogoRemover" titulo="Remover prazo?" botaoSim="Remover" botaoNao="Cancelar" :loading="excluindo">
      Prazo selecionado será removido do sistema.
    </z-dialogo-sim-nao>

    <v-form v-model="form_valido" lazy-validation ref="formulario">
      <z-dialogo ref="dialogoAdicionar" largura="800px" titulo="Prazo de Pagamento" dividers persistent @fechar="$refs.formulario.resetValidation()">

          <template v-slot:conteudo>
            <v-row dense>
              <v-col cols="12">
                <z-text-field caps="upper" v-model="prazo.descricao" ref="descricao" label="Descrição" placeholder=" " :rules="[regras.campoObrigatorio]"></z-text-field>
              </v-col>
              <v-col cols="6">
                <z-campo-valor v-model="prazo.parcelas" decimais="0" ref="parcelas" label="Parcelas" suffix="x" placeholder=" " :rules="[regras.naoNegativo]"></z-campo-valor>
              </v-col>
              <v-col cols="6">
                <z-campo-valor v-model="prazo.juros" decimais="0" ref="juros" label="Juros" suffix="%" placeholder=" " :rules="[regras.naoNegativo]"></z-campo-valor>
              </v-col>
            </v-row>
          </template>

          <template v-slot:actions_right>
            <v-btn text @click="$refs.dialogoAdicionar.fechar()" :disabled="salvando">Cancelar</v-btn>
            <v-btn color="primary" ref="btnConfirmar" @click="confirmar" :loading="salvando" :disabled="!form_valido">Confirmar</v-btn>
          </template>
      </z-dialogo>
    </v-form>

  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";

import * as regras from '@/app/helpers/validacoes';

export default {
  name: 'PrazosLista',
  data() {
    return {
      headers: [
        { text: "Código", value: "id", width: "150px" },
        { text: "Descrição", value: "descricao" },
        { text: "Parcelas", value: "parcelas", align: "right" },
        { text: "Juros", value: "juros", align: "right" },
        { text: "Opções", value: "", width: "200px", align: "center", sortable: false },
      ],
      excluindo: false,
      salvando: false,
      form_valido: true,
      regras: {...regras}
    };
  },

  computed: {
    ...mapState(['loading']),
    ...mapState('prazos', ['prazos', 'prazo', 'total_itens']),

    busca: {
      get () {
        return this.$store.state.prazos.busca
      },
      set (busca) {
        this.$store.commit('prazos/SET_BUSCA', busca);
      }
    },

    paginacao: {
      get () {
        return this.$store.state.prazos.paginacao
      },
      set (paginacao) {
        this.$store.commit('prazos/UPDATE_PAGINACAO', paginacao);
      }
    },
  },

  created() {
    this.refresh();
  },

  mounted() {
    this.setTitulo("Prazos");
  },

  methods: {
    ...mapMutations(["setTitulo", 'LOADING_OFF']),
    ...mapActions("prazos", ["listar", "excluir", "abrir", "atualizar", "salvar"]),

    async refresh() {
      try {
        await this.listar();
      } catch (error) {
        console.log(error);
        this.$eventbus.notificar("Não foi possível listar os prazos.");
      }
    },

    buscar() {
      this.$store.commit('prazos/SET_PAGE', 1);
      this.refresh();
    },
    
    limparBusca() {
      this.busca = null;
      this.$store.commit('prazos/SET_PAGE', 1);
      this.refresh();
    },

    adicionar() {
      this.$store.commit('prazos/ZERAR');
      this.$refs.dialogoAdicionar.abrir();
    },

    async editar(prazo) {
      try {

        await this.abrir(prazo.id);
        this.$refs.dialogoAdicionar.abrir();
        
      } catch (error) {
        console.log(error);
        this.$eventbus.notificar("Não foi possível abrir o prazo selecionado.");
      } finally {
        this.LOADING_OFF();
      }
    },

    async confirmar() {
      if (!this.$refs.formulario.validate()) {
        return false;
      }

      try {
        this.salvando = true;

        if (this.prazo.id) {
          await this.atualizar(this.prazo);
        } else {
          await this.salvar(this.prazo);
        }

        this.$refs.dialogoAdicionar.fechar();
        this.$eventbus.notificar("Prazo salvo com sucesso");
      } catch(error) {
        this.$eventbus.notificarErro('Não foi possível salvar este prazo. Verifique os dados preenchidos.', error);
        throw error;
      } finally {
          this.salvando = false;
      }
    },

    perguntarExcluir(prazo) {
      this.$refs.dialogoRemover.abrir()
        .then(async response => {
          if (response == true) {
            await this.confirmarExcluir(prazo);
            this.$refs.dialogoRemover.fechar();
          }
        })
    },

    async confirmarExcluir(prazo) {
      try {
        this.excluindo = true;
        await this.excluir(prazo.id);
        this.$eventbus.notificar("Prazo excluído com sucesso!");
      } catch (error) {
        this.$eventbus.notificar("Não foi possível excluir o prazo selecionado!");
        throw error;
      } finally {
        this.excluindo = false;
      }
    },
  },

  watch: {
    paginacao: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
</style>
